import React from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import PortfolioSquare from './PortfolioSquare';

const PortfolioList = ({ portfolios,
                         backgroundImage = "https://storage.googleapis.com/finiat-web-static-resources/dramatic/black-podium.jpeg",
    actions = null
                       }) => {
    const navigate = useNavigate();

    const handleNavigate = (portfolioId) => {
        navigate(`/public/portfolio/${portfolioId}`);
    };

    // Slick slider settings
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: false,
        centerPadding: '100px',
    };

    return (
        <div style={{ height: 800, width: 1200, borderRadius: '25px', position: 'relative' }}>
            {/* Background and Carousel Wrapper */}
            <div
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: '100% 100%',
                    backgroundPosition: 'center',
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '10px',
                    position: 'relative',
                    borderRadius: '25px'
                }}
            >
                {/* Overlay text listing portfolios on the left */}
                <div style={{
                    position: 'absolute',
                    left: '20px',
                    top: '30%',
                    transform: 'translateY(-60%)',
                    color: 'white',
                    fontSize: '18px',
                    zIndex: 2, // Ensure it is on top
                }}>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        {portfolios.map(portfolio => (
                            <li key={portfolio.id} style={{ marginBottom: '10px', color: 'rgba(159, 159, 152, 0.5)', fontSize: '14px' }} className={'cursor'}>
                                {portfolio.name}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Carousel */}
                <div
                    style={{
                        width: '60%',
                        maxWidth: '1300px',
                        height: 'auto',
                        position: 'relative',
                        marginBottom: '60px',
                        marginLeft: '20%',
                    }}
                >
                    <Slider {...settings}>
                        {portfolios.map((portfolio) => (
                            <div
                                key={portfolio.id}
                                style={{
                                    padding: '10px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <PortfolioSquare
                                    portfolio={portfolio}
                                    height={300}
                                    width={450}
                                    onClick={() => handleNavigate(portfolio.id)}
                                    actions={actions}
                                />
                            </div>
                        ))}
                    </Slider>
                </div>

                {/* Left and Right navigation buttons */}
                <button
                    style={{
                        position: 'absolute',
                        left: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: 'transparent',
                        border: 'none',
                        fontSize: '24px',
                        color: 'white',
                        cursor: 'pointer',
                        zIndex: 3, // On top of carousel
                    }}
                    onClick={() => document.querySelector('.slick-prev').click()} // Trigger Slick prev
                >
                    &#10094; {/* Left arrow symbol */}
                </button>
                <button
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: 'transparent',
                        border: 'none',
                        fontSize: '24px',
                        color: 'white',
                        cursor: 'pointer',
                        zIndex: 3, // On top of carousel
                    }}
                    onClick={() => document.querySelector('.slick-next').click()} // Trigger Slick next
                >
                    &#10095; {/* Right arrow symbol */}
                </button>
            </div>
        </div>
    );
};

export default PortfolioList;
